module.exports = __webpack_public_path__ + "img/week-off-option.9ab86b6d.webp";